import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'
import { useReactivateGuild } from 'app/frontend/base/config/mutations'
import { useTeam } from 'app/frontend/base/config/context/team'
import { TriangleAlert } from 'lucide-react'

const InactiveGuildAlert = () => {
  const { guild } = useTeam()
  const reactivateGuild = useReactivateGuild()

  if (guild.active) return null

  return (
    <Alert variant='warning' className='my-4'>
      <TriangleAlert size={16} />
      <AlertTitle>Guild inactive</AlertTitle>
      <AlertDescription className='flex items-center justify-between gap-4'>
        <span>
          This guild has been marked as inactive and is no longer being
          refreshed.
        </span>
        <Button
          variant='outline'
          size='sm'
          onClick={() => reactivateGuild.mutate(guild)}
          disabled={reactivateGuild.isPending}
        >
          Reactivate guild
        </Button>
      </AlertDescription>
    </Alert>
  )
}

export default InactiveGuildAlert
